export let Code = {
type: `@Component({
    selector: 'p-selectButton',
    template:
        <p-selectButton [options]="cities1" [(ngModel)]="selectedCity1"></p-selectButton>
        <p-selectButton [options]="cities2" [(ngModel)]="selectedCity2" optionLabel="name"></p-selectButton>
})
export class SelectButton {

}
`,
typeMu: `@Component({
    selector: 'p-selectButton',
    template:
        <p-selectButton [options]="cities" [(ngModel)]="selectedCities" multiple="multiple"></p-selectButton>
})
export class SelectButton {

}
`,
typeIcon: `@Component({
    selector: 'p-selectButton',
    template:
        <p-selectButton [options]="types" [(ngModel)]="selectedType" multiple="multiple"></p-selectButton>
})
export class SelectButton {
	types: SelectItem[];
    selectedType: string;

    constructor() {
       	this.types = [];
        this.types.push({title: 'Paypal', value: 'PayPal', icon: 'fa ion-monitor'});
        this.types.push({title: 'Visa', value: 'Visa', icon: 'fa ion-iphone'});
        this.types.push({title: 'MasterCard', value: 'MasterCard', icon: 'fa ion-ipod'});
    }
}
`
};


// WEBPACK FOOTER //
// ./src/app/code/selectButton.ts